<script setup>
import { computed } from 'vue';

const props = defineProps({
    threat: {
        type: Object,
        required: true,
    },
    isActive: {
        type: Boolean,
        default: false,
    },
});

</script>

<template>
    <div
        class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center bg-gray-900/50 rounded-2xl p-8 border border-white/10 backdrop-blur-sm">
        <!-- Image Side -->
        <div
            class="relative aspect-square w-full rounded-xl overflow-hidden bg-black/40 flex items-center justify-center border border-white/5">
            <img v-if="threat.image" :src="threat.image" :alt="threat.title" class="object-cover w-full h-full" />
            <div v-else class="text-white/20 text-4xl font-bold">IMAGE</div>
        </div>

        <!-- Content Side -->
        <div class="text-left space-y-8">
            <h3 class="text-3xl font-bold text-white">{{ threat.title }}</h3>

            <div class="space-y-2">
                <h4 class="text-white font-semibold text-lg">{{ $t('landingPage.v2.threats.labels.example') }}</h4>
                <p class="text-gray-400 leading-relaxed">{{ threat.example }}</p>
            </div>

            <div class="space-y-2">
                <h4 class="text-white font-semibold text-lg">{{ $t('landingPage.v2.threats.labels.reality') }}</h4>
                <p class="text-gray-400 leading-relaxed">{{ threat.reality }}</p>
            </div>

            <div class="space-y-2">
                <h4 class="text-white font-semibold text-lg">{{ $t('landingPage.v2.threats.labels.liability') }}</h4>
                <p class="text-gray-400 leading-relaxed">{{ threat.liability }}</p>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
